import { getPrescriptionEntryList } from './get-prescription-entry-list.js';

function getConfiguratorDocument(content, noAddonsImage) {
    var ref;
    if (!content) {
        return {
            addOnsStep: {
                noAddonsImage
            },
            prescriptionStep: {},
            prescriptionFormStep: {},
            prescriptionUploadStep: {},
            packageStep: {}
        };
    }
    const { addOnStepReadMore , packageStepReadMore , prescriptionStepDescription , prescriptionStepImage , prescriptionFormStepDescription , prescriptionFormStepImage , prescriptionStepEntryTypes , prescriptionStepMeasure ,  } = content;
    const entryTypes = getPrescriptionEntryList(prescriptionStepEntryTypes);
    var ref1;
    return {
        prescriptionStep: {
            entryTypes,
            measureDescription: (ref1 = prescriptionStepMeasure === null || prescriptionStepMeasure === void 0 ? void 0 : (ref = prescriptionStepMeasure.description) === null || ref === void 0 ? void 0 : ref.value) !== null && ref1 !== void 0 ? ref1 : undefined
        },
        prescriptionUploadStep: {
            description: prescriptionStepDescription === null || prescriptionStepDescription === void 0 ? void 0 : prescriptionStepDescription.value,
            image: prescriptionStepImage
        },
        prescriptionFormStep: {
            description: prescriptionFormStepDescription === null || prescriptionFormStepDescription === void 0 ? void 0 : prescriptionFormStepDescription.value,
            image: prescriptionFormStepImage
        },
        packageStep: {
            readMoreLink: !!(packageStepReadMore === null || packageStepReadMore === void 0 ? void 0 : packageStepReadMore.url) ? packageStepReadMore : undefined
        },
        addOnsStep: {
            readMoreLink: !!(addOnStepReadMore === null || addOnStepReadMore === void 0 ? void 0 : addOnStepReadMore.url) ? addOnStepReadMore : undefined,
            noAddonsImage
        }
    };
}

export { getConfiguratorDocument };
//# sourceMappingURL=get-configurator-document.js.map
